"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgsOnlineTheme = void 0;
exports.rgsOnlineTheme = {
    'thema-id': 'rgs-2',
    logo: 'url',
    common: {
        radius: '4px',
        radius12: '12px',
        radius32: '32px',
        radiusXXS: '4px',
        radiusXS: '8px',
        radiusS: '12px',
        radiusM: '16px',
        radiusL: '24px',
        radiusXL: '32px',
        'font-family': 'Golos Text',
        'icons-toggle': true,
        'icons-url-prefix': '-pick-',
        'box-shadow': 'box-shadow: 0px 8px 25px rgba(99, 119, 156, 0.2)',
        'box-shadow2': 'box-shadow: 0px -8px 8px 0px rgba(99, 119, 156, 0.08)',
        a: {
            color: '#00A0EF',
            decoration: 'none',
        },
    },
    colors: {
        surface: {
            primary: '#FFFFFF',
            secondary: '#E8F3F4',
            background: '#F0F6F6',
            brand: '#00EEF5',
            brand2: '#FF4643',
            accent: '#1698D9',
            interactive: {
                'interactive-tined': '#C5FCFC',
                'interactive-light': '#DDFDFC',
            },
            success: {
                'success-tined': '#C8F4D9',
                'success-light': '#E6FEF0',
            },
            warning: {
                'success-tined': '#FAE1C1',
                'success-light': '#FDEFDD',
            },
            error: {
                'success-tined': '#F8D9D8',
                'success-light': '#FEE7E7',
            },
            'matt-glass': {
                'success-tined': {
                    background: 'gba(255, 255, 255, 0.8)',
                    'background-filter-blur': '32px',
                },
                'success-light': {
                    background: 'rgba(241, 242, 246, 0.8)',
                    'background-filter-blur': '32px',
                },
            },
        },
        text: {
            primary: '#1A1D1E',
            inverse: '#FFFFFF',
            secondary: '#737B8C',
            tertiary: '#A2ADC1',
            interactive: '#00A0EF',
            'interactive-clarified': '#0088CC',
            success: '#23CD64',
            warning: '#FFA024',
            error: '#FF5452',
        },
        neutral: {
            '0': '#FFFFFF',
            '10': '#F1F2F6',
            '20': '#E4E7EE',
            '30': '#DCE1EF',
            '50': '#A2ADC1',
            '70': '#8591A9',
            '80': '#63779C',
            '100': '#1A1D1E',
        },
        accent: {
            interactive: {
                normal: '#1698D9',
                darkened: '#0088CC',
                clarified: '#6EC9F7',
                faded: '#9EDBFA',
            },
            action: {
                normal: '#00EEF5',
                darkened: '#00D0D6',
                clarified: '#C5FCFC',
                faded: '#DDFDFC',
            },
            success: {
                normal: '#23CD64',
                darkened: '#1B9D4C',
                clarified: '#C8F4D9',
                faded: '#E6FEF0',
            },
            warning: {
                normal: '#FFA024',
                darkened: '#E58200',
                clarified: '#FAE1C1',
                faded: '#FDEFDD',
            },
            error: {
                normal: '#FF5452',
                darkened: '#CF1A17',
                clarified: '#F8D9D8',
                faded: '#FEE7E7',
            },
        },
        'on-accent': {
            primary: '#1A1D1E',
            darkened: '#E4E4E5',
            secondary: '#FFFFFF',
            tertiary: 'background: rgba(252, 252, 255, 0.4)',
            quaternary: 'rgba(252, 252, 255, 0.2)',
        },
        overlay: {
            primary: 'rgba(31, 35, 43, 0.5)',
            secondary: 'rgba(90, 97, 128, 0.1)',
            ripple: {
                interactive: 'rgba(22, 152, 217, 0.15)',
                success: 'rgba(51, 204, 102, 0.15)',
                warning: ' rgba(255, 136, 51, 0.15)',
                error: 'rgba(243, 86, 106, 0.15)',
            },
        },
        gradient: {
            home: 'linear-gradient(103.18deg, #F53D55 8.82%, #B14C98 37.31%, #5864E1 65.8%, #25A4F4 94.29%)',
            health: 'linear-gradient(180deg, #0E91E4 0.01%, #44FDAF 100%)',
            pet: 'linear-gradient(315deg, #EA66FF 0%, #FF5C69 50%, #FFAA00 100%)',
            sport: 'linear-gradient(135deg, #1AA1E5 0%, #0BDAC9 50%, #C4EA06 100%)',
            'anti-mite': 'linear-gradient(345.96deg, #F199FF 0%, #5C33FF 100%)',
        },
        icon: {
            primary: '#1A1D1E',
            inverse: '#FFFFFF',
            secondary: '#00EEF5',
            tertiary: '#FF4643',
            quaternary: '#8591A9',
            success: '#23CD64',
            warning: '#FFA024',
            error: '#FF5452',
        },
        product: {
            travel: '#D9EDFF',
            apartment: '#FFF3DC',
            house: '#FFEECF',
            mortgage: '#F5F5F5',
            sport: '#D4FCFF',
            pet: '#FFEFF8',
            antimite: '#E1FAC9',
            health: '#DEFFDF',
            partner: '#F6E2FF',
        },
        additional: {
            light: {
                yellow: '#FFF3DC',
                orange: '#FFE0CF',
                green: '#DEFFDF',
                blue: '#D4FCFF',
                lime: '#E1FAC9',
                'dark-blue': '#D9EDFF',
                pink: '#FFEFF8',
                neutral: '#F5F5F5',
                purple: '#F6E2FF',
            },
            darkened: {
                yellow: '#B87900',
                orange: '#B84000',
                green: '#00B806',
                blue: '#00ABB8',
                lime: '#5AA810',
                'dark-blue': '#0061B8',
                pink: '#B80067',
                neutral: '#5C5C5C',
                purple: '#7F00B8',
            },
            partners: {
                gosuslugi: '#0D4CD3',
            },
        },
    },
    components: {
        risks: {
            'text-toggle': true,
            'icons-toggle': true,
            'icons-url-prefix': '-pick-',
        },
    },
};
